import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TimeDateService } from './time-date.service';
import { SubtitlesService } from './subtitles.service';
import { ParametersService } from './parameters.service';
import { UserService } from './user.service';
import {AppAlertService} from "./app-alert.service";
import {AlarmTile} from "../models";

@Injectable({
  providedIn: 'root'
})
export class AlarmHistoryService {
  loading: boolean = false;
  type: string = 'all';
  fromDate: string;
  toDate: string;
  typeDatePicker: string;
  showFromDatePicker: boolean = false;
  showToDatePicker: boolean = false;
  search = { txt: '' };
  alarm: AlarmTile[] = [];
  tempAlarm: any[] = [];

  constructor(
      private http: HttpClient,
      private timeDate: TimeDateService,
      private subtitles: SubtitlesService,
      private parameters: ParametersService,
      private user: UserService,
      private appAlert: AppAlertService,
  ) {}

  getAlarmHistory(): void {

    const moduleUdid = this.parameters.selectedModuleHash;
    const type = this.type || 'all';
    const fromDate = this.fromDate;
    const toDate = this.toDate;
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);

    if (fromDateObj >= toDateObj) {
      this.appAlert.showAppAlert(this.subtitles.setSubtitle(15172),this.subtitles.setSubtitle(1136), null, false, null);
    }
    else {
      this.loading = true;
      this.http.get(`/api/v1/users/${this.user.user_id}/modules/${moduleUdid}/alarm_history/from/${fromDate}/to/${toDate}/type/${type}`)
          .subscribe({
            next: (response: any) => {
              this.search.txt = '';
              this.alarm = response;
              this.tempAlarm = response;
              this.loading = false;
            }
          });
    }
  }

  setDatePicker(type: string): void {
    this.typeDatePicker = type;

    if (type === 'fromDate') {
      this.timeDate.date = this.fromDate;
      this.showFromDatePicker = true;
    } else if (type === 'toDate') {
      this.timeDate.date = this.toDate;
      this.showToDatePicker = true;
    }
  }

  hideDatePicker(): void {
    if (this.typeDatePicker === 'fromDate') {
      this.fromDate = this.timeDate.date;
      this.showFromDatePicker = false;
    } else if (this.typeDatePicker === 'toDate') {
      this.toDate = this.timeDate.date;
      this.showToDatePicker = false;
    }
  }

  searchText(): void {
    if (this.search.txt.length >= 1) {
      this.alarm = [];
      this.searchTextInArray();
    } else if (this.search.txt.length === 0) {
      this.alarm = this.tempAlarm;
    }
  }

  private searchTextInArray(): void {
    const searchText = this.search.txt.toLowerCase();
    this.alarm = this.tempAlarm.filter(val => {
      const subtitle = val.txtId > 0 ? this.subtitles.setSubtitle(val.txtId).toLowerCase() : '';
      return subtitle.includes(searchText);
    });
  }
}
